<template>
  <div class="elevation-1">
    <v-toolbar flat>
      <v-btn flat to="/devices/devices"> Devices </v-btn>
      <v-btn flat to="/devices/plan"> Plan </v-btn>
			<v-menu offset-y v-if="$is_admin()">
        <template slot="activator" slot-scope="{ on }">
          <v-btn v-on="on" flat class="pr-1" v-model="$route.path.startsWith('/devices/models')"> Models <v-icon dark>arrow_drop_down</v-icon> </v-btn>
        </template>
        <v-list>
          <v-list-tile :to="get_model_to_uri(device_type)" v-for="device_type in device_types" :id="device_type">
            <v-list-tile-title>{{device_type.title}}</v-list-tile-title>
          </v-list-tile>

        </v-list>
      </v-menu>
      <v-btn flat to="/devices/locations"> Locations </v-btn>

    </v-toolbar>
    <v-flex xs12>
	  	<router-view></router-view>
	  </v-flex>
  </div>
</template>

<script>

/*import DeviceList from './devices/List'
import DevicePlan from './devices/Plan'
import DeviceModels from './devices/Models'
import DeviceLocations from './devices/Locations'
import DeviceRead from './devices/Read'
import DeviceEditor from './devices/Editor'
import ListDataEditor from './content/ListDataEditor'*/

import DevicesPage from './devices/Devices'
import ModelsPage from './devices/Models'
import PlanPage from './devices/Plan'
import LocationsPage from './devices/Locations'
import SettingsModel from '@/models/settings.js';


export default {
	computed: {
		device_types () {
			return SettingsModel.list("device_type");
		}
	},
	methods: {
		get_model_to_uri(device) {
      var form = device.value.form;
      var fitem = _.find(form, function(f) {
        return f.name == "model";
      })
      var content_list_id = fitem.content_id;
			return "/devices/models/list/" + content_list_id;
		}
	},
	routes: [
		{
			path: '',
			redirect: 'devices'
		},
  	{
      path: 'devices',
      component: DevicesPage,
      children: DevicesPage.routes
    },
    {
    	path: 'models',
    	component: ModelsPage,
    	children: ModelsPage.routes
    },
    {
    	path: 'plan',
    	component: PlanPage,
    	children: PlanPage.routes
    },
    {
    	path: 'locations',
    	component: LocationsPage,
    	children: LocationsPage.routes
    }
   ]
}
</script>
